import type { Item } from "./types";

export const MAX_NUMBER_OF_WIDGETS_FOR_AI_PROCESS = 70;

export const MIN_NUMBER_OF_SYMBOLS = 5;

export const TEXT_WIDGET_LEFT_MARGIN = 30;

export const TEXT_WIDGET_TOP_MARGIN = 50;

export const SNACKBAR_TIMEOUT = 7000;

export const AI_MENU_BUTTON_CLASS = "wm_aiassistant";

export const AI_MENU_BUTTON_SVG_CLASS = "wm_aiassistant_svg";

export const AI_MENU_BUTTON_ANIMATION_CLASS = "wm_aiassistant_animation";

export const AI_SUBMENU_CLASS = "wm_aiassistant_submenu";

export const AI_SUBMENU_HEADER_CLASS = "wm_aiassistant_submenu_header";

export const AI_SUBMENU_TITLE_CLASS = "wm_aiassistant_submenu_title";

export const AI_SUBMENU_BUTTON_CLASS = "wm_aiassistant_submenu_button";

export const AI_SUBMENU_ITEM_CLASS = "wm_aiassistant_submenu_item";

export const CREATE_SUB_MENU_ITEMS: Item[] = [
    {
        title: "Итоги ретро",
        action: "retro_summary",
        icon: `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_153_8922)">
                <path
                d="M13.83 17.2491L11.7925 17.7883C9.90663 18.2883 8.9633 18.5375 8.22496 18.1283C7.4858 17.72 7.23996 16.8116 6.74746 14.9966L5.52913 10.5041C5.03746 8.68829 4.7908 7.78079 5.2233 7.06246C5.65663 6.34329 6.59913 6.09329 8.48496 5.59413L11.8183 4.71079C13.705 4.21246 14.6475 3.96246 15.3866 4.37163C16.125 4.77996 16.3716 5.68829 16.8633 7.50329L18.0866 12.0141C18.2958 12.7858 18.4008 13.1725 18.2858 13.535M13.83 17.2491C14.4566 17.0825 14.4616 17.0808 14.9491 16.6625L17.235 14.7C17.8591 14.165 18.1708 13.8975 18.2858 13.535M13.83 17.2491C13.83 17.2491 14.32 13.4216 15.4166 12.9166C16.6608 12.3441 18.2858 13.535 18.2858 13.535"
                stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                d="M14.1667 4.16749C14.1134 3.27332 13.9642 2.70999 13.54 2.30666C12.89 1.68832 11.8484 1.68499 9.76338 1.67832L6.07755 1.66749C3.99255 1.66166 2.95005 1.65916 2.30421 2.27332C1.65838 2.88749 1.66171 3.87999 1.66755 5.86499L1.68255 10.7758C1.68921 12.76 1.69171 13.7525 2.34088 14.3708C2.99088 14.9892 4.03338 14.9925 6.11838 14.9983L6.68588 15"
                stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_153_8922">
                <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>`,
    },
    {
        title: "Краткое содержание",
        action: "short_summary",
        icon: `
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.5 5.83333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H5.83333M14.1667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V5.83333M17.5 14.1667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H14.1667M5.83333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V14.1667M5.83333 6.66667H12.5M5.83333 10H14.1667M5.83333 13.3333H10.8333"
            stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>`,
    },
];

export const EDIT_SUB_MENU_ITEMS: Item[] = [
    {
        title: "Исправить ошибки",
        action: "fix_errors",
        icon: `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_153_8940)">
                <path
                    d="M17.6141 6.75713C17.6141 5.75427 17.4899 4.63285 17.3427 3.54999C17.2445 2.86111 16.9008 2.23091 16.3747 1.77545C15.8486 1.32 15.1757 1.06997 14.4799 1.07142H4.20557C3.51023 1.07066 2.838 1.321 2.31252 1.77639C1.78705 2.23178 1.44368 2.8616 1.34557 3.54999C1.19557 4.63285 1.07129 5.75427 1.07129 6.75856C1.07129 7.76142 1.19557 8.88427 1.34557 9.9657C1.44368 10.6541 1.78705 11.2839 2.31252 11.7393C2.838 12.1947 3.51023 12.445 4.20557 12.4443H7.27415M18.9284 11.7857L11.7856 18.9286M11.7856 11.7857L18.9284 18.9286M5.40986 6.5757V6.94142M9.34272 6.5757V6.94142M13.277 6.5757V6.94142"
                    stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_153_8940">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>`,
    },
    {
        title: "Сократить",
        action: "shorten",
        icon: `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M5.8335 17.5C7.21421 17.5 8.3335 16.3807 8.3335 15C8.3335 13.6193 7.21421 12.5 5.8335 12.5C4.45278 12.5 3.3335 13.6193 3.3335 15C3.3335 16.3807 4.45278 17.5 5.8335 17.5Z"
                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M12.5002 12.5L5.8335 2.5M7.50016 12.5L10.0002 8.75M14.1668 2.5L11.6668 6.25" stroke="black"
                stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M14.167 17.5C15.5477 17.5 16.667 16.3807 16.667 15C16.667 13.6193 15.5477 12.5 14.167 12.5C12.7863 12.5 11.667 13.6193 11.667 15C11.667 16.3807 12.7863 17.5 14.167 17.5Z"
                stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>`,
    },
    {
        title: "Упростить",
        action: "simplify",
        icon: `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.5 8.33333V16.25C17.5 16.5815 17.3683 16.8995 17.1339 17.1339C16.8995 17.3683 16.5815 17.5 16.25 17.5H3.75C3.41848 17.5 3.10054 17.3683 2.86612 17.1339C2.6317 16.8995 2.5 16.5815 2.5 16.25V3.75C2.5 3.41848 2.6317 3.10054 2.86612 2.86612C3.10054 2.6317 3.41848 2.5 3.75 2.5H12.5"
                stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6.6665 8.33335L10.8332 11.6667L17.0832 2.91669" stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>`,
    },
];

export const TOAST_PRO_CONTENT = "Ваш помощник";

export const TOAST_FREE_CONTENT = "Ваш помощник (тариф Pro)";
